/* eslint-disable no-console */
import React, { useCallback, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { getVideoByFinanceType } from "../../../../utils/getVideoByFinanceType";
import { BackgroundVideoPlayer } from "../../../../components/BackgroundVideoPlayer";
import { detailedFinanceRoutesMap } from "../../../../constants";
import { scrollToDOMNode, VerticalPagination } from "../../../../components/VerticalPagination";
import { useStyles } from "./styled";
import { FinanceBenefits } from "../FinanceBenefits";
import { AccountingSoftware } from "../AccountingSoftware";

export const DetailedFinanceComponent = ({
  financeType,
  selectedFinanceType,
  isIslamicBanking,
  handleClickonReadMoreBtn
}) => {
  const classes = useStyles();
  const firstSection = useRef(null);
  const secondSection = useRef(null);
  const thirdSection = useRef(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }, []);

  const scrollToSection = useCallback(
    i => scrollToDOMNode([firstSection, secondSection, thirdSection][i]),
    []
  );
  const { origin } = window.location;
  const canonicalUrl = origin + detailedFinanceRoutesMap[financeType]["conventional"];
  //video hide for both desktop and mobile as per new requirement
  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <VerticalPagination scrollToSection={scrollToSection}>
        <div ref={firstSection} className="hide-on-mobile-desktop">
          <BackgroundVideoPlayer
            video={getVideoByFinanceType(financeType, isIslamicBanking)}
            classes={{ container: "hide-on-mobile-desktop" }}
            handleClick={handleClickonReadMoreBtn}
          />
        </div>
        <div ref={secondSection} className={classes.section}>
          <FinanceBenefits financeType={selectedFinanceType} isIslamicBanking={isIslamicBanking} />
        </div>
        <div ref={thirdSection} className={classes.section}>
          <AccountingSoftware />
        </div>
      </VerticalPagination>
    </>
  );
};
